import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** *********************  START ADD GROUP WISE LOAN PROPOSAL  ******************** */
export const createNewGroupWiseLoan = (addData: any) => {
	const data = {
		AddLoanIndexDataToken: addData,
	};
	const url = `${API_URL}addGroupWiseLoanIndex`;
	return makeApiCall(url, data);
};
/** *********************  END ADD GROUP WISE LOAN PROPOSAL  ******************** */

/** *********************  START UPDATE GROUP WISE LOAN PROPOSAL  ******************** */
export const updateGroupWiseLoan = (updateData: any) => {
	const data = {
		UpdateALoanIndexToken: updateData,
	};
	const url = `${API_URL}updateGroupWiseLoanIndex`;
	return makeApiCall(url, data);
};
/** *********************  END UPDATE GROUP WISE LOAN PROPOSAL  ******************** */

export const getSubGroupList = (deleteData: any) => {
	const data = {
		GetSubGroupDetailsToken: deleteData,
	};
	const url = `${API_URL}GetSubGroupListToken`;
	return makeApiCall(url, data);
};
